export default __webpack_public_path__ + "static/media/login-img.35cf0663.svg";